import _ from 'lodash';
import moment from 'moment';
import { stringify } from 'qs';
import { pageTabs } from '../components/app/workersList';
import { completedOnboardStatusesList, inprogressOnboardStatusesList } from '../constants/general';
import { jobWorkerStatuses, jobWorkerStatusesFilter } from '../constants/jobs';
import { uiDateFormatShort } from '../constants/date';

const allowedFilterParams = [
  'full_name',
  'state',
  'background_status',
  'tax_type',
  'skill',
  'is_active',
  'rating',
  'distance',
  'zip'
];

/**
 * @param {object} filterParams
 * @return {object}
 * */
export function stringifyWorkerFilterParams (filterParams) {
  const { filteringValues: { ...filter }, selectedTab } = filterParams;
  const filterData = {};

  for (let key in filter) {
    if (filter.hasOwnProperty(key)) {
      if (!allowedFilterParams.includes(key)) {
        continue;
      }

      const filterParam = filter[key];
      if ((_.isString(filterParam) && filterParam.length) || _.isBoolean(filterParam) || _.isInteger(filterParam)) {
        filterData[key] = filterParam;
      } else if (_.isArray(filterParam) && filterParam.length) {
        filterData[key] = filterParam.map(item => item.value || item);
      }
    }
  }

  filterData.onboarding_statuses = selectedTab === pageTabs.inprogress.id
    ? inprogressOnboardStatusesList : completedOnboardStatusesList;

  const queryString = !_.isEmpty(filterData) ? `&${stringify(filterData)}` : '';
  const urlString = `&${stringify({ selectedTab })}` + queryString;

  return ({ queryString, urlString });
}

/**
 * @return {array}
 * */
export function getJobWorkerStatusesForFilter () {
  return jobWorkerStatuses.filter(status => jobWorkerStatusesFilter.includes(status.id));
}

/**
 * @param {string} payroll_date
 * @return {string}
 * */
export function getWorkerPayrollDate (payroll_date) {
  if (payroll_date) {
    return moment.utc(payroll_date).format(uiDateFormatShort);
  }

  return moment().add(2, 'week').isoWeekday(4).format(uiDateFormatShort);
}

/**
 * @param {object} data
 * @return {object}
 */
export function extractWorkerData (data) {
  const { onboarding_status, payroll_employee_id, is_gravy_valid, workerNewPhotoUrl,
    first_name, last_name, email, phone, gender, language_id, secondary_language_id,
    has_car, address, address2, state, city, zip, address_coordinates, photo_image_url
  } = data;

  return {
    first_name,
    last_name,
    email,
    phone,
    gender,
    language_id,
    secondary_language_id,
    has_car,
    address,
    address2,
    city,
    state,
    zip,
    address_coordinates,
    photo_image_url: workerNewPhotoUrl || photo_image_url,
    onboarding_status,
    payroll_employee_id,
    is_gravy_valid
  };
}



// WEBPACK FOOTER //
// ./src/helpers/workers.js